import {useQuery, useMutation} from 'admin/lib/apollo'
import {useQueryParams, StringParam, NumberParam, ArrayParam, withDefault} from 'use-query-params'
import {GET_ACCOUNTS, UPDATE_ACCOUNTS, MERGE_ACCOUNTS} from 'admin/gql/Accounts.gql'
import useDestroyable from './useDestroyable'

export default (organisationId, {state} = {state: 'active'}) => {
  const [filters, setFilters] = useQueryParams({
    q: withDefault(StringParam, ''),
    includeGroupIds: withDefault(ArrayParam, []),
    excludeGroupIds: withDefault(ArrayParam, []),
    referredById: StringParam,
    dashboard: StringParam,
    bounds: StringParam,
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 50),
    sortBy: withDefault(StringParam, 'name'),
    sortDirection: withDefault(StringParam, 'asc'),
    sortLabel: withDefault(StringParam, 'Name')
  })

  const {data: {accounts = {}} = {}} = useQuery(GET_ACCOUNTS, {
    variables: {organisationId, state, ...filters}
  })

  const [activate] = useMutation(UPDATE_ACCOUNTS, {
    variables: {organisationId, state: 'active'},
    flash: 'Accounts activated',
    refetchQueries: [
      {query: GET_ACCOUNTS, variables: {organisationId, state: 'active', ...filters}},
      {query: GET_ACCOUNTS, variables: {organisationId, state: 'archived', ...filters}}
    ]
  })

  const [archive] = useMutation(UPDATE_ACCOUNTS, {
    variables: {organisationId, state: 'archived'},
    flash: 'Accounts archived',
    refetchQueries: [
      {query: GET_ACCOUNTS, variables: {organisationId, state: 'active', ...filters}},
      {query: GET_ACCOUNTS, variables: {organisationId, state: 'archived', ...filters}}
    ]
  })

  const [merge] = useMutation(MERGE_ACCOUNTS, {
    variables: {organisationId},
    flash: 'Accounts merged',
    refetchQueries: [{query: GET_ACCOUNTS, variables: {organisationId, state, ...filters}}]
  })

  const [update] = useMutation(UPDATE_ACCOUNTS, {
    variables: {organisationId},
    flash: 'Accounts updated'
  })

  const {destroy, errors: destroyError} = useDestroyable('Account')

  return {
    filters,
    setFilters,
    errors: destroyError || {},
    accounts: accounts.collection || [],
    totalCount: accounts.metadata ? accounts.metadata.totalCount : 0,
    destroy,
    activate,
    archive,
    merge,
    update
  }
}
